var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.33333C5 1.49238 6.49238 0 8.33333 0H11.6667C13.5076 0 15 1.49238 15 3.33333H19.1667C19.6269 3.33333 20 3.70643 20 4.16667C20 4.6269 19.6269 5 19.1667 5H18.2927L17.7802 15.2497C17.6472 17.9107 15.4508 20 12.7865 20H7.21354C4.54917 20 2.35283 17.9107 2.21978 15.2497L1.70729 5H0.833333C0.373096 5 0 4.6269 0 4.16667C0 3.70643 0.373096 3.33333 0.833333 3.33333H5ZM3.37604 5L3.88436 15.1665C3.97307 16.9405 5.43729 18.3333 7.21354 18.3333H12.7865C14.5627 18.3333 16.0269 16.9405 16.1156 15.1665L16.624 5H3.37604ZM13.3333 3.33333H6.66667C6.66667 2.41286 7.41286 1.66667 8.33333 1.66667H11.6667C12.5871 1.66667 13.3333 2.41286 13.3333 3.33333ZM7.5 8.33333C7.96024 8.33333 8.33333 8.70643 8.33333 9.16667V13.3333C8.33333 13.7936 7.96024 14.1667 7.5 14.1667C7.03976 14.1667 6.66667 13.7936 6.66667 13.3333V9.16667C6.66667 8.70643 7.03976 8.33333 7.5 8.33333ZM12.5 8.33333C12.9602 8.33333 13.3333 8.70643 13.3333 9.16667V13.3333C13.3333 13.7936 12.9602 14.1667 12.5 14.1667C12.0398 14.1667 11.6667 13.7936 11.6667 13.3333V9.16667C11.6667 8.70643 12.0398 8.33333 12.5 8.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDelete);
export default __webpack_public_path__ + "static/media/white-delete.8c86cb8fd53e8309dce2473167d20464.svg";
export { ForwardRef as ReactComponent };